export const columna = {
	nombre: "Columna",
	dia: "Martes Santo",
	nombrecompleto:
		"Venerable, Real y Muy Ilustre Archicofradía de la Santísima Resurrección de Nuestro Señor Jesucristo y Penitencia de Nuestro Padre Jesús Atado a la Columna y Azotes y María Santísima de las Lágrimas",
	sede: "Parroquia de San Antonio",
	pasos: 2,
	distancia: [1320, 1110],
	penitentes: 215,
	cargadores: 108,
	web: "http://www.diariodecadiz.es/semana_santa/Columna_0_1229277815.html",

	ida: [
		{ lng: -6.2993047, lat: 36.5344955 },
		{ lng: -6.2989801, lat: 36.5347821 },
		{ lng: -6.2984598, lat: 36.5343339 },
		{ lng: -6.297698, lat: 36.5350752 },
		{ lng: -6.2966466, lat: 36.5346787 },
		{ lng: -6.2960109, lat: 36.5339643 },
		{ lng: -6.2954584, lat: 36.5340182 },
		{ lng: -6.2936642, lat: 36.5319238 },
		{ lng: -6.2929441, lat: 36.5311029 },
		{ lng: -6.2922133, lat: 36.5302949 },
		{ lng: -6.2928379, lat: 36.5297864 },
		{ lng: -6.2945294, lat: 36.5296271 },
		{ lng: -6.2950766, lat: 36.5295301 },
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 }
	],
	vuelta: [
		// CATEDRAL
		{ lng: -6.29535, lat: 36.52899 },
		{ lng: -6.2957105, lat: 36.529088 },
		{ lng: -6.2954074, lat: 36.5297562 },
		{ lng: -6.2956676, lat: 36.5299588 },
		{ lng: -6.295276, lat: 36.5303489 },
		{ lng: -6.2950225, lat: 36.5308338 },
		{ lng: -6.2949219, lat: 36.5308392 },
		{ lng: -6.2949246, lat: 36.5314524 },
		{ lng: -6.2964803, lat: 36.5317843 },
		{ lng: -6.2964106, lat: 36.5318619 },
		{ lng: -6.2967914, lat: 36.5325397 },
		{ lng: -6.2964347, lat: 36.5329222 },
		{ lng: -6.2962738, lat: 36.5332455 },
		{ lng: -6.2963355, lat: 36.5332972 },
		{ lng: -6.2962684, lat: 36.5339513 },
		{ lng: -6.2980118, lat: 36.534752 },
		{ lng: -6.2984625, lat: 36.5342951 },
		{ lng: -6.2989855, lat: 36.5347541 },
		{ lng: -6.2992859, lat: 36.5344761 }
	],
	markers: [
		{
			name: "Salida",
			hora: "2018-03-27T18:45",
			latlng: [36.53446, -6.29929]
		},
		{
			name: "Nueva",
			hora: "2018-03-27T20:25",
			latlng: [36.53062, -6.29249]
		},
		{
			name: "Catedral",
			hora: "2018-03-27T21:25",
			latlng: [36.52899, -6.29535]
		},
		{
			name: "Candelaria",
			hora: "2018-03-27T22:25",
			latlng: [36.53106, -6.295]
		},
		{
			name: "Palillero",
			hora: "2018-03-27T22:50",
			latlng: [36.53196, -6.2965]
		},
		{
			name: "Valverde Barrié",
			hora: "2018-03-27T23:00",
			latlng: [36.53254, -6.29679]
		}
	],
	itinerario: [
		[
			"Plaza de San Antonio (Dcha.)",
			"Ancha",
			"San Jose (Izd.)",
			"Plaza de Mina",
			"Tinte",
			"Plaza San Francisco",
			"Rosario",
			"Beato Diego de Cadiz (Izda.)",
			"San Francisco",
			"Plaza San Agustín",
			"San Francisco",
			"Nueva"
		],
		[
			"Plaza San Juan de Dios",
			"Pelota",
			"Plaza Pio XII",
			"Estación de Penitencia en la S.I.C."
		],
		[
			"Arquitecto Acero",
			"Plaza de Pío XII",
			"Compañía",
			"Santiago",
			"Plaza Candelaria"
		],
		["Montañés", "Palillero"],
		["Novena", "Valverde"],
		[
			"San Pedro",
			"San Jose (Izda.)",
			"Ancha (Dcha.)",
			"Plaza de San Antonio (izq.)"
		]
	],
	mapConfig: {
		center: [36.5311, -6.29721],
		zoom: 17
	}
};



// WEBPACK FOOTER //
// ./src/data/procesiones/columna.js